<template>
  <div class="businessDiagnosis">
    <!-- 顶部背景 -->
    <div class="top-banner-box">
      <div class="top-banner-img" :style="{ backgroundImage: `url(${headerBgUrl})` }">
        <div class="top-banner-center">
          <div class="banner-btn1" @click="onClickLookMore">企业诊断</div>
          <div class="banner-btn2" @click="onClickLookMore">企业诊断</div>
        </div>
      </div>
    </div>
    <!-- 填报入口 -->
    <div class="entrance">
      <div class="diagnosis-title">填报入口</div>
      <div class="entrance-box wow animate__animated animate__zoomIn">
        <div
          v-for="(item, index) in entraList"
          :key="index"
          class="entraItem"
          @mouseover="entraIndex = index + 1"
          @mouseout="entraIndex = ''"
          :class="entraIndex == index + 1 ? 'entrance-bg' : ''"
          @click="onclickEntrance(index + 1)"
        >{{ item.title }}</div>
      </div>
    </div>
    <!-- 填报培训 -->
    <div class="train">
      <div class="diagnosis-title">填报培训</div>
      <div class="train-box">
        <div
          v-for="(item, index) in trainList"
          :key="index"
          class="trainItem"
          @click="onClickPlayDetail(item, 'live')"
        >
          <div class="trainItem-top" :style="{ backgroundImage: `url(${item.pic})` }">
            <img v-if="!item.pic" class="emptyBg" src="../../assets/publicService/empty.jpg" alt />
            <div v-if="item.stage == 'DOING'" class="liveing">直播中</div>
            <div v-else-if="item.stage == 'NOT_START'" class="notStart">未开始</div>
            <div v-else-if="item.stage == 'END'" class="notStart">已结束</div>
          </div>
          <div class="trainItem-bottom">
            <div class="trainItem-bottom-title over-num-lines">{{ item.title }}</div>
            <div class="trainItem-bottom-content over-num-lines over-3-lines">{{ item.summary }}</div>
            <div class="trainItem-bottom-time">{{ item.startDate | dateFormat }}</div>
          </div>
        </div>
        <div v-if="trainList.length == 0" class="empty">暂无数据</div>
      </div>
      <div class="seeMore" @click="onClickLiveMore">查看更多</div>
    </div>
    <!-- 关于企业指标 -->
    <div class="target">
      <div class="diagnosis-title">关于企业指标</div>
      <div class="target-box">
        <el-tabs v-model="activeName" @tab-click="handleClick" @before-leave="beforeLeave">
          <el-tab-pane
            :label="item.name"
            :name="(index * 1 + 1).toString()"
            v-for="(item, index) in targetList"
            :key="index"
          >
            <div class="target-con">
              <div class="targetItem">
                <div class="targetItem-left">
                  <div
                    v-for="(title, index2) in item.titleList"
                    :key="index2"
                    class="targetItem-left-con"
                    @mouseover="targetIndex = index2 + 1"
                    :class="targetIndex == index2 + 1 ? 'cur' : ''"
                    @mouseout="targetIndex = '1'"
                  >
                    <div
                      class="targetItem-icon"
                      :style="{ backgroundImage: `url(${title.icon})` }"
                    />
                    <div class="targetItem-title">{{ title.name }}</div>
                  </div>
                </div>
                <div class="targetItem-right">
                  <div
                    v-for="(con, index3) in item.titleList"
                    :key="index3"
                    v-show="targetIndex == index3 + 1"
                    class="mainWrap"
                  >
                    <div class="mainTitle">{{ con.content["title"] }}</div>
                    <div class="mainCon">{{ con.content["detail"] }}</div>
                  </div>
                </div>
              </div>
            </div>
          </el-tab-pane>
        </el-tabs>
      </div>
    </div>
    <!-- 联系方式+在线客服 -->
    <!-- <div class="contact">
      <div class="leftImg"></div>
      <div class="rightImg"></div>
      <div class="contact-way">
        <div class="contact-way-title">
          联系方式
          <div style="color:#ABABAB;font-size: 16px;margin-top: 12px;">
            为您提供工作日咨询服务
          </div>
        </div>
        <div class="contact-way-con">
          <div>邮箱：hui.yang@kocel.com</div>
          <div style="display:flex">
            <div style="width:45px">电话：</div>
            <div style="flex:1">
              马玲 15769682963（微信同号） 杨慧 18169504873（微信同号）
            </div>
          </div>
          <div style="display:flex">
            <div style="width:45px">地址：</div>
            <div style="flex:1">
              银川市金凤区六盘山路与良田渠街交叉口东150米国家智能铸造产业产业创新中心
            </div>
          </div>
        </div>
      </div>
      <div class="contact-service">
        <div class="contact-service-title">
          在线客服
          <div style="color:#ABABAB;font-size: 16px;margin-top: 12px;">
            联系我们一对一指导
          </div>
        </div>
        <div class="contact-service-con">
          <div
            class="qrcode"
            :style="{ backgroundImage: `url(${codeUrl})` }"
          ></div>
          <div>培训负责人微信</div>
        </div>
      </div>
    </div>-->
  </div>
</template>
<script>
import { getDictionaryItem, queryLive } from "../../utils/interface";
export default {
  name: "businessDiagnosis",
  components: {},
  data() {
    return {
      headerBgUrl: "",
      entraList: [
        {
          icon: require("../../assets/publicService/enterpriseDia/46.png"),
          title: "智能制造"
        },
        {
          icon: require("../../assets/publicService/enterpriseDia/46.png"),
          title: "两化融合"
        },
        {
          icon: require("../../assets/publicService/enterpriseDia/46.png"),
          title: "企业上云"
        },
        {
          icon: require("../../assets/publicService/enterpriseDia/46.png"),
          title: "中小企业数字化水平"
        }
      ], // 填报入口List
      trainList: [
        {
          stage: "NOT_START",
          pic: "",
          title: "诊断评估线上培训",
          summary:
            "汇聚一批不同行业、领域资深专家、充分发挥专家工作，提供智力支持和技术保障，为政策指定、评估专业支撑,为政策指定、评估专业支撑为政策指定、评估专业支撑。",
          startDate: "2024年3月20日 19：30"
        },
        {
          stage: "DOING",
          pic: require("../../assets/publicService/enterpriseDia/44.png"),
          title: "诊断评估线上培训",
          summary:
            "汇聚一批不同行业、领域资深专家、充分发挥专家工作，提供智力支持和技术保障，为政策指定、评估专业支撑。",
          startDate: "2024年3月20日 19：30"
        },
        {
          stage: "END",
          pic: require("../../assets/publicService/enterpriseDia/44.png"),
          title: "诊断评估线上培训",
          summary:
            "汇聚一批不同行业、领域资深专家、充分发挥专家工作，提供智力支持和技术保障，为政策指定、评估专业支撑。",
          startDate: "2024年3月20日 19：30"
        }
      ],
      entraIndex: "", //填报入口当前位置
      activeName: "1",
      codeUrl: require("../../assets/publicService/enterpriseDia/code.jpg"),
      targetList: [
        {
          name: "智能制造",
          titleList: [
            {
              icon: require("../../assets/publicService/enterpriseDia/2.png"),
              name: "什么是智能制造能力成熟度评估？",
              content: {
                title: "什么是智能制造能力成熟度评估？",
                detail: `\n     智能制造能力成熟度评估是一种用于评估企业智能制造水平的方法，它通过全面、系统和细致的评估来确定企业的智能制造能力现状和发展方向。这一评估有助于企业满足市场和客户需求，并制定合理的智能制造技术和管理策略。智能制造能力成熟度评估采用成熟度模型，涵盖管理、技术、组织、人员等方面，旨在预测企业未来的发展方向，并提供优化建议，从而提升企业的各项指标。`
              }
            },
            {
              icon: require("../../assets/publicService/enterpriseDia/4.png"),
              name: "为什么要进行评估？",
              content: {
                title: "为什么要进行评估？",
                detail:
                  "\n     通过各市工信部门和工业园区组织规上工业企业参与线上诊断评估，可全面了解辖区内规上工业企业智能制造现状，并为企业实施智能改造提供指导，持续推进区域智能制造发展水平和能力提升。企业通过自测报告，准确了解当前智能制造水平，帮助企业识别差距、找出短板，制定下一步改造规划。"
              }
            },
            {
              icon: require("../../assets/publicService/enterpriseDia/1.png"),
              name: "如何进行评估？",
              content: {
                title: "如何进行评估？",
                detail:
                  "\n     智能制造能力成熟度评估工作采用在线填报的方式进行，登录宁夏工业企业数字化转型公共服务平台，注册并填报相关数据（已注册填报过的企业，可直接登录）。"
              }
            },
            {
              icon: require("../../assets/publicService/enterpriseDia/3.png"),
              name: "等级和模型",
              content: {
                title: "等级和模型",
                detail:
                  `\n     为了带动国内制造业企业高质量发展，帮助企业分层次、分阶段、系统化地推进智能制造演进升级，在国家工信部指导下，国家市场监督管理总局和国家标准化委员会于2020年10月联合发布了《GB∕T 39116-2020 智能制造能力成熟度模型》以及《GB/T 39117-2020智能制造能力成熟度评估方法》。` +
                  `\n     根据《智能制造能力成熟度模型》，制造业企业智能制造成熟度从低到高分为五级，即：` +
                  `\n     一级为流程化管理（规划级）` +
                  `\n     二级为数字化改造（规范级）` +
                  `\n     三级为网络化集成（集成级）` +
                  `\n     四级为智能化生产（优化级）` +
                  `\n     五级为产业链创新（引领级）`
              }
            }
          ]
        },
        {
          name: "企业上云",
          titleList: [
            {
              icon: require("../../assets/publicService/enterpriseDia/2.png"),
              name: "什么是企业上云水平评估？",
              content: {
                title: "什么是企业上云水平评估？",
                detail:
                  "\n     企业上云水平评估是依据2019年9月自治区工业和信息化厅发布的《宁夏工业企业上云认定标准》开展的面向全区规上工业企业的企业基于自身业务发展和信息技术应用需求，使用计算、存储、网络、平台、软件等云服务的现状评估。"
              }
            },
            {
              icon: require("../../assets/publicService/enterpriseDia/4.png"),
              name: "为什么要进行企业上云水平评估？",
              content: {
                title: "为什么要进行企业上云水平评估？",
                detail:
                  "\n     日益激烈的市场竞争环境对企业的生存和发展提出了更高的要求，上云已经成为企业转型突破的一大风口，通过评估衡量规上工业企业上云规模、程度和水平，综合评价企业云上数字化转型的深度及成效，找出问题和需求，促进制造业企业云上数字化协同和高质量发展。"
              }
            },
            {
              icon: require("../../assets/publicService/enterpriseDia/1.png"),
              name: "如何进行评估？",
              content: {
                title: "如何进行评估？",
                detail:
                  "\n     企业上云水平评估工作采用在线填报的方式进行，登录宁夏工业企业数字化转型公共服务平台，注册并填报相关数据（已注册填报过的企业，可直接登录）。"
              }
            },
            {
              icon: require("../../assets/publicService/enterpriseDia/3.png"),
              name: "等级和模型",
              content: {
                title: "等级和模型",
                detail:
                  `\n     根据宁夏机械工程学会发布的《宁夏企业"上云"评价指标体系》，将企业上云等级分为：` +
                  `\n     A级（综合评估分数85≤X≤100）：企业资金投入充足、合理，与企业远景发展、战略规划需求的符台性高；形成了兼具互联网信息化与业务流程管理职能的创新组织形态;互联网化和信息化在企业各项业务规划中得到充分落实。` +
                  `\n     B级（综合评估分数75≤X<85）：企业根据业务发展需求能够合理规划和增大资金投入；互联网化和信息化组织参与企业策；制定企业级专项互联网化和信息化规划。` +
                  `\n     C级（综合评估分数65≤X<75）：企业资金投入初步满足企业业务发展需要，适度性较好；设置专门的互联网化和信息化组织；业务规划制定逐渐考虑互联网技术应用。` +
                  `\n     D级（综合评估分数<65）：企业建设资金投入低；互联网化和信息化组织建设刚刚起步；互联网化和信息化规划没有引起重视。`
              }
            }
          ]
        },
        {
          name: "两化融合",
          titleList: [
            {
              icon: require("../../assets/publicService/enterpriseDia/2.png"),
              name: "什么是两化融合水平评估？",
              content: {
                title: "什么是两化融合水平评估？",
                detail:
                  "\n     信息化与工业化融合发展简称“两化融合”。两化融合由国家工信部主导，是制造企业为顺应“工业化”与“信息化”深度融合的发展趋势而产生的。两化融合水平评估是对企业信息化与工业化融合发展水平进行的评估，包括水平与能力评估、效能与效益评估两个部分，通过开展评估，企业可了解当前两化融合水平现状和发展定位，有效提升信息化环境下的核心竞争力。"
              }
            },
            {
              icon: require("../../assets/publicService/enterpriseDia/4.png"),
              name: "为什么要进行评估？",
              content: {
                title: "为什么要进行评估？",
                detail:
                  "\n     两化融合评估是企业根据自身发展状况进行的线上自我评估，基于全国企业两化融合评估数据库和诊断对标模型，为参评规上工业企业在线实时反馈评估报告，帮助企业了解其两化水平、所处阶段、各项关键指标与全国同行业、同规模企业的对标情况等。"
              }
            },
            {
              icon: require("../../assets/publicService/enterpriseDia/1.png"),
              name: "如何进行评估？",
              content: {
                title: "如何进行评估？",
                detail:
                  "\n     两化融合水平评估工作采用在线填报的方式进行，登录宁夏工业企业数字化转型公共服务平台，注册并填报相关数据（已注册填报过的企业，可直接登录）。"
              }
            },
            {
              icon: require("../../assets/publicService/enterpriseDia/3.png"),
              name: "等级和模型",
              content: {
                title: "等级和模型",
                detail:
                  "\n     根据工信部发布的《信息化和工业化融合管理体系 要求》（GB/T 23001-2017）等系列标准，两化融合贯标等级由低到高划分为A（规范级）、AA（场景级）、AAA（领域级）、AAAA（平台级）和AAAAA（生态级）等五个等级，不同等级能力呈现不同的状态特征以及能力单元/能力模块的过程维、要素维、管理维的不同建设重点。"
              }
            }
          ]
        },
        {
          name: "中小企业数字化水平",
          titleList: [
            {
              icon: require("../../assets/publicService/enterpriseDia/2.png"),
              name: "什么是中小企业数字化水平评估？",
              content: {
                title: "什么是中小企业数字化水平评估？",
                detail:
                  "\n     中小企业数字化水平评估是通过对企业在数字化转型过程中的关键要素进行测量和评估，来判断企业的数字化程度和成熟度的一种方法，帮助中小企业了解自身在数字化发展方面的现状，找出自身在数字化转型中存在的问题和瓶颈，并制定相应的改进和提升措施。"
              }
            },
            {
              icon: require("../../assets/publicService/enterpriseDia/4.png"),
              name: "为什么要进行评估？",
              content: {
                title: "为什么要进行评估？",
                detail:
                  "\n     在当前全球数字化浪潮的推动下，国家对于中小企业数字化发展越来越重视，通过评估中小企业的数字化水平，有助于政府和相关机构制定出更科学、更有效的支持政策和措施，为中小企业提供更好的数字化转型发展环境和条件，促进其持续健康发展。"
              }
            },
            {
              icon: require("../../assets/publicService/enterpriseDia/1.png"),
              name: "如何进行评估？",
              content: {
                title: "如何进行评估？",
                detail:
                  "\n     中小企业数字化水平评估工作采用在线填报的方式进行，登录宁夏工业企业数字化转型公共服务平台，注册并填报相关数据（已注册填报过的企业，可直接登录）。"
              }
            },
            {
              icon: require("../../assets/publicService/enterpriseDia/3.png"),
              name: "等级和模型",
              content: {
                title: "等级和模型",
                detail:
                  "\n     为助力中小企业数字化转型，工业和信息化部办公厅组织相关单位共同研究制定了《中小企业数字化水平评测指标（2022年版）》。" +
                  "\n     《评测指标》根据行业特点，分为制造业数字化水平评测表、生产性服务业数字化水平评测表、其他行业数字化水平评测表三个类别，从数字化基础、经营、管理、成效四个维度综合评估中小企业数字化发展水平，依据企业评测得分，将数字化水平划分为四个等级:" +
                  "\n     一级（20—40分）：开展了基础业务流程梳理和数据规范化管理，并进行了信息技术简单应用。" +
                  "\n     二级（40—60分）：利用信息技术手段或管理工具实现了单一业务数字化管理。" +
                  "\n     三级（60—80分）：应用信息系统及数字化技术进行数据分析，实现全部主营业务数字化管控。" +
                  "\n     四级（80分以上）：利用全业务链数据集成分析，实现数据驱动的业务协同与智能决策。"
              }
            }
          ]
        }
      ],
      targetIndex: "1" // 指标当前位置
    };
  },
  created() {
    this.getOptionsData();
  },
  filters: {
    dateFormat(str) {
      if (str) {
        return str.split(" ")[0];
      } else {
        return;
      }
    }
  },
  mounted() {
    window.addEventListener("scroll", this.menu);
    this.tbpxQueryLive();
  },
  methods: {
    getOptionsData() {
      //顶部背景图
      getDictionaryItem({
        code: "QYZD_BANNER"
      }).then(res => {
        if (res != null && res.length > 0) {
          this.headerBgUrl = res[0].value;
        } else {
          this.headerBgUrl = "";
        }
      });
    },
    onClickLookMore() {},
    // 点击入口
    onclickEntrance(index) {
      if (index == 4) {
        this.$message({
          showClose: true,
          message: "敬请期待",
          type: "warning"
        });
      } else if (index == 1) {
        window.open("https://www.c3mep.cn/login", "_blank");
      } else if (index == 2) {
        window.open("https://nxpg.cspiii.com/userLogin", "_blank");
      } else if (index == 3) {
        window.open("/cloudUp", "_blank");
      }
    },
    // 页面滚动
    menu() {
      //这里是pc端
      let scroll =
        document.documentElement.scrollTop || document.body.scrollTop;
      // console.log('scroll  ' + scroll)
      if (scroll > 1000) {
        // this.showService = true
      }
      if (scroll > 2000) {
        // this.showManage = true
      }
    },
    // 直播-查看更多
    onClickLiveMore() {
      let route = this.$router.resolve({
        path: "/diagnosisVLList"
      });
      window.open(route.href, "_blank");
    },
    // 企业培训
    tbpxQueryLive() {
      queryLive({
        current: 1,
        pageSize: 3,
        status: 1,
        rec: 1,
        programUuid: "ZB_TBPX",
        stage: "" //(NOT_START-未开始，DOING-进行中，END-已结束，全部-'')
      }).then(res => {
        if (res && res.list.length > 0) {
          this.trainList = res.list;
        } else {
          this.trainList = [];
        }
      });
    },
    // 点击直播跳转详情页
    onClickPlayDetail(item, type) {
      // console.log('详情：', item)
      let routeData = this.$router.resolve({
        path: "/diagnosisDetail",
        query: {
          uuid: item.uuid,
          type: type,
          titleName: "企业诊断",
          titleForm: "businessDiagnosis"
        }
      });
      window.open(routeData.href, "_blank");
    },
    // tab页
    handleClick(tab, event) {
      // console.log(tab, event);
      // if (tab.index * 1 + 1 == 4) {
      //     event.stopPropagation()
      //     this.$message({
      //         showClose: true,
      //         message: '敬请期待',
      //         type: 'warning'
      //     })
      //     return
      // }
    },
    beforeLeave(newTab) {
      // console.log('newTab'+newTab)
    }
  }
};
</script>
<style scoped lang="less">
.businessDiagnosis {
  position: relative;
  top: -80px;
  margin-bottom: -80px;

  .over-num-lines {
    word-break: break-all;
    text-overflow: ellipsis;
    display: -webkit-box;
    -webkit-box-orient: vertical;
    -webkit-line-clamp: 1;
    overflow: hidden;
  }

  .over-3-lines {
    -webkit-line-clamp: 3;
  }

  .empty {
    font-size: 24px;
    font-weight: 500;
    color: #5566779e;
    position: absolute;
    left: 50%;
    top: 50%;
    transform: translate(-50%, -50%);
  }

  .top-banner-box {
    background-color: #f7f8fb;

    .top-banner-img {
      height: 500px;
      width: 100%;
      overflow: hidden;
      background-repeat: no-repeat;
      background-size: 100% 100%;
      display: flex;
      justify-content: center;
      align-items: center;

      .top-banner-center {
        width: 1300px;
        height: 500px;
        position: relative;
      }

      .banner-btn1,
      .banner-btn2 {
        width: 130px;
        color: transparent;
        letter-spacing: 2px;
        text-align: center;
        border-radius: 7px;
        cursor: pointer;
        user-select: none;
        position: absolute;
        bottom: 156px;
        left: 124px;
        transition: all 0.2s;
        cursor: pointer;
      }

      .banner-btn2 {
        left: 269px;
      }

      // .banner-btn:active {
      //     transform: scale(1.02);
      // }
    }
  }

  /* 公共title */
  .diagnosis-title {
    font-size: 28px;
    font-weight: 700;
    color: #000;
    text-align: center;
    margin: 15px 0 10px;
  }

  /* 填报入口 */
  .entrance {
    background: url("../../assets/publicService/enterpriseDia/11-1.jpg")
      no-repeat center center / 100% 100%;
    height: 220px;
    overflow: hidden;

    .entrance-box {
      width: 1300px;
      margin: 0 auto;
      display: flex;
      flex-flow: row wrap;
      justify-content: space-between;
      align-items: center;

      .entrance-bg {
        color: #fff !important;
        background: url("../../assets/publicService/enterpriseDia/46-1.png")
          center center/100% 100%;
      }

      .entraItem {
        width: 300px;
        height: 106px;
        background-color: #fff;
        display: flex;
        justify-content: center;
        align-items: center;
        font-size: 24px;
        font-weight: 700;
        text-align: center;
        padding: 15px;
        box-sizing: border-box;
        transition: all 0.2s;
        color: #000;
        box-shadow: 0 0 5px #9999996e;
        border-radius: 12px;

        &:hover {
          transform: scale(1.05);
          cursor: pointer;
        }
      }
    }
  }

  /* 填报培训 */
  .train {
    background-color: #fcfcfd;
    height: 575px;
    overflow: hidden;
    width: 1300px;
    margin: auto;

    .train-box {
      width: 1300px;
      height: 435px;
      margin: 0 auto;
      display: flex;
      flex-flow: row wrap;
      justify-content: space-between;
      position: relative;

      .trainItem {
        width: 410px;
        height: 405px;
        border-radius: 20px;
        display: flex;
        flex-flow: column nowrap;
        justify-content: space-between;
        align-items: start;
        box-shadow: 0 0 4px #33445530;
        cursor: pointer;
        transition: all 0.2s;

        &:hover {
          transform: scale(1.02);
        }

        &-top {
          width: 100%;
          height: 235px;
          background: no-repeat center center/100% 100%;
          position: relative;
          background-origin: border-box;
          border-radius: 20px;
          border-bottom-left-radius: 0;
          border-bottom-right-radius: 0;

          .emptyBg {
            width: 100%;
            height: 235px;
            position: absolute;
            background: no-repeat center center/100% 100%;
          }

          & > div {
            position: absolute;
            width: 75px;
            height: 40px;
            display: flex;
            justify-content: center;
            align-items: center;
            color: #efefef;
            font-size: 16px;
            font-weight: bold;
          }

          .liveing {
            background: url("../../assets/publicService/enterpriseDia/47.png")
              no-repeat center center/100% 100%;
          }

          .notStart {
            background: url("../../assets/publicService/enterpriseDia/48.png")
              no-repeat center center/100% 100%;
          }
        }

        &-bottom {
          flex: 1;

          & > div {
            padding: 0 10px;
          }

          &-title {
            font-size: 24px;
            font-weight: 600;
            color: #000;
            height: 30px;
            margin: 15px 0 0;
          }

          &-content {
            color: #445566;
            margin-top: 10px;
          }

          &-time {
            color: #2d50a1;
            font-weight: bold;
            margin-top: 20px;
          }
        }
      }
    }

    .seeMore {
      font-size: 15px;
      cursor: pointer;
      color: #000;
      text-align: center;

      &:hover {
        color: #2d50a1;
      }
    }
  }

  /* 关于企业指标 */
  .target {
    overflow: hidden;

    .target-box {
      .target-con {
        min-height: 300px;
        background: url("../../assets/publicService/enterpriseDia/44.png")
          no-repeat center center/100% 100%;

        .targetItem {
          width: 1300px;
          height: auto;
          min-height: 300px;
          margin: 0 auto;
          display: flex;
          flex-flow: row nowrap;
          justify-content: space-between;
          align-items: stretch;

          .targetItem-left {
            width: 360px;

            .cur {
              background-color: #2d59b2 !important;
            }

            .targetItem-left-con {
              width: 100%;
              height: 130px;
              background-color: #022463;
              box-sizing: border-box;
              padding: 0 50px;
              display: flex;
              flex-flow: row nowrap;
              justify-content: start;
              align-items: center;
              border-bottom: 1px solid #2f5dbb;

              &:last-child {
                border: none;
              }

              .targetItem-icon {
                width: 54px;
                height: 50px;
                margin-right: 20px;
                background: no-repeat center/100% 100%;
              }

              .targetItem-title {
                flex: 1;
                color: #eee;
                font-size: 22px;
                font-weight: bold;
              }
            }
          }

          .targetItem-right {
            width: 890px;
            box-sizing: border-box;
            padding: 20px;
            display: flex;
            flex-flow: column nowrap;
            justify-content: space-between;

            .mainWrap {
              height: 100%;

              .mainTitle {
                font-size: 24px;
                font-weight: bold;
                color: white;
              }

              .mainCon {
                color: #ffffff;
                white-space: break-spaces;
                line-height: 2.5;
                font-weight: 600;
                letter-spacing: 1.5px;
                margin-left: 10px;
              }
            }
          }
        }
      }
    }
  }

  /* 联系方式，在线客服 */
  .contact {
    width: 100%;
    height: 300px;
    background: url("../../assets/publicService/enterpriseDia/newBg.jpg");
    position: relative;

    & > div {
      width: 365px;
      height: 252px;
      position: absolute;
      top: 60px;
      height: 250px;
      padding: 10px 40px;
      box-sizing: border-box;
      display: flex;
      flex-flow: column nowrap;
      justify-content: space-evenly;
      align-items: start;
    }

    .leftImg,
    .rightImg {
      width: 252px;
      height: 249px;
      top: 27px;
      position: absolute;
      background: no-repeat center center/100% 100%;
    }

    .leftImg {
      left: 302px;
      background: url("../../assets/publicService/enterpriseDia/15.jpg")
        no-repeat center center/100% 100%;
    }

    .rightImg {
      right: 545px;
      background-image: url("../../assets/publicService/enterpriseDia/16.jpg");
    }

    .contact-way,
    .contact-service {
      color: black;

      .contact-way-title,
      .contact-service-title {
        font-size: 24px;
      }

      .contact-way-con,
      .contact-service-con {
        font-size: 15px;
        color: #545454;

        & > div {
          margin-top: 10px;
        }
      }
    }

    .contact-way {
      width: 520px;
      left: 553px;
      top: 27px;
      border: 1px solid #b9b4b452;
      border-left: none;
      justify-content: center;
    }

    .contact-service {
      right: 300px;
      top: 27px;
      width: 245px;
      border: 1px solid #b9b4b452;
      border-left: none;
      justify-content: center;

      .contact-service-con {
        display: flex;
        flex-flow: column nowrap;
        // align-items: center;
        // align-self: center;

        .qrcode {
          width: 95px;
          height: 95px;
          // border: 1px solid #567;
          background: no-repeat center center/100% 100%;
        }
      }
    }
  }

  /deep/ .el-tabs__nav {
    transform: translateX(-50%) !important;
    left: 50%;
    font-size: 24px;
    font-weight: bold;
  }

  /deep/ .el-tabs__item {
    font-size: 24px !important;
    font-weight: bold;
    padding: 0px;
    margin: 0 80px;
  }

  /deep/ .el-tabs__item:hover {
    color: #2d50a1;
    cursor: pointer;
  }

  /deep/ .el-tabs__item.is-active {
    color: #2d50a1;
    box-shadow: 0 -3px 0 #2d50a1 inset;
  }

  /deep/ .el-tabs__active-bar {
    background-color: transparent;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/businessDiagnosis/index.vue